import { NOTE } from '@/types.ts';
import { NOTES } from '@/core/contants.ts';

const noteKeys = Object.keys(NOTES);

function noteIndex(note: NOTE): number {
  return noteKeys.findIndex((key) => note === key);
}

export function offsetKey(note: NOTE, offset: number): NOTE {
  const index = noteIndex(note);

  return noteKeys[(index + offset) % noteKeys.length];
}
